





































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FacetValueViewObject, FacetViewObject, SelectionTypeViewObject } from '@/types/apiServerContract';
import Accordion from '@/core/ui-components/Accordion.vue';
import urlHelper from '@/core/urlHelper.service';
import gtmService from '@/project/tracking/gtm/GTM.service';
import dictionaryService from '@/core/translation/dictionary.service';
import FacetPickerRecommendedBrands from './modules/FacetPickerRecommendedBrands.vue';
import { BRAND_FACET_KEY } from './constants';
import { IFacetPicker } from './IFacetPicker';
import { PRICE_FACET_KEY } from '@/project/search/constants';

@Component({
    components: { Accordion, FacetPickerRecommendedBrands }
})
export default class MobileFacets extends Vue implements IFacetPicker {
    @Prop({
        type: Array,
        default: () => []
    })
    private facets!: FacetViewObject[];

    get brandFacet(): FacetViewObject | undefined {
        if (!this.facets || !this.facets.length) {
            return undefined;
        }

        return this.facets.find(({ facetId }) => BRAND_FACET_KEY);
    }

    private isPriceFilter(facet: FacetViewObject) {
        return facet.facetId === PRICE_FACET_KEY;
    }

    private tooltipMessage(facet: FacetViewObject) {
        return this.isPriceFilter(facet) && !facet.enabled ? dictionaryService.get('Search.Facets.PriceSortDisabled') : '';
    }

    private isSingleSelect(facet: FacetViewObject): boolean {
        return facet.selectionType === SelectionTypeViewObject.SingleSelect;
    }

    private shouldUpdateLastFacet(facet: FacetViewObject): boolean {
        return facet.isFacet;
    }

    private isValueDisabled(value: FacetValueViewObject) {
        return !value.isFacet && value.productCount === 0;
    }

    public toggle(facetValue: FacetValueViewObject, facet: FacetViewObject) {
        // Logic is inversed - if false - it will now be true (toggled)
        if (this.isSingleSelect(facet)) {
            for (const value of facet.values) {
                value.selected = value.key === facetValue.key && !value.selected;
            }
        } else {
            facetValue.selected = !facetValue.selected;
        }

        if (!facetValue.selected) {
            gtmService.trackFacet(facet, facetValue);
        }

        this.updateFacetValue(facetValue, facet);
    }

    private updateFacetValue(value: FacetValueViewObject, facet: FacetViewObject) {
        if (value.selected) {
            gtmService.trackFacet(facet, value);
        }

        if (this.isSingleSelect(facet)) {
            const values = value.selected ? [value.key] : [];
            urlHelper.setFacetValues(facet.facetId, values, this.shouldUpdateLastFacet(facet));
        } else {
            urlHelper.updateFacetValue(facet.facetId, value.key, value.selected, this.shouldUpdateLastFacet(facet));
        }
    }

    private hasValues(facet: FacetViewObject): boolean {
        return facet.values.length > 0;
    }

    private getFacetName(facet: FacetViewObject) : string {
        if (facet.facetDisplayLabel) {
            return dictionaryService.get(facet.facetDisplayLabel);
        }

        return facet.facetDisplayName;
    }

    private getFacetValueName(facet: FacetValueViewObject) : string {
        if (dictionaryService.exists(facet.displayLabel)) {
            return dictionaryService.get(facet.displayLabel);
        }

        return dictionaryService.translate(facet.displayName);
    }
}
